import React from 'react';
import PropTypes from 'prop-types';
import ArgonBox from 'components/ArgonBox';

// Importar todos los iconos SVG
import TvIcon from '../../assets/icons/tv-minimal.svg';
import UserIcon from '../../assets/icons/user-round.svg';
import BanknoteArrowDownIcon from '../../assets/icons/banknote-arrow-down.svg';
import UserRoundPlusIcon from '../../assets/icons/user-round-plus.svg';
import UploadIcon from '../../assets/icons/upload.svg';
import ReceiptTextIcon from '../../assets/icons/receipt-text.svg';
import HistoryIcon from '../../assets/icons/history.svg';
import UsersIcon from '../../assets/icons/users.svg';

const iconMap = {
  'tv-minimal': TvIcon,
  'user-round': UserIcon,
  'banknote-arrow-down': BanknoteArrowDownIcon,
  'user-round-plus': UserRoundPlusIcon,
  'upload': UploadIcon,
  'receipt-text': ReceiptTextIcon,
  'history': HistoryIcon,
  'users': UsersIcon,
};

function CustomIcon({ iconName, color = "dark", fontSize = "14px", active = false, ...props }) {
  const IconComponent = iconMap[iconName];
  
  if (!IconComponent) {
    console.warn(`Icono "${iconName}" no encontrado`);
    return null;
  }

  // Debug: verificar cuando un icono está activo
  if (active) {
  }

  // Crear un objeto de props limpio que excluya 'active' y otras props no válidas para elementos DOM
  // Esto previene que 'active' se propague al elemento <img> a través de ArgonBox
  // Es crítico porque React.cloneElement puede fusionar props y 'active' podría terminar
  // en las props restantes, lo que causaría que se pase al elemento DOM
  const safeProps = {};
  const excludedProps = ['active']; // Lista de props que NO deben pasarse al DOM
  
  Object.keys(props).forEach(key => {
    if (!excludedProps.includes(key)) {
      safeProps[key] = props[key];
    }
  });

  return (
    <ArgonBox 
      component="img" 
      src={IconComponent} 
      alt={iconName}
      sx={{
        width: fontSize,
        height: fontSize,
        filter: active ? 
               "brightness(0) saturate(100%) invert(49%) sepia(79%) saturate(1009%) hue-rotate(200deg) brightness(98%) contrast(89%)" :
               color === "primary" ? "brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)" :
               color === "warning" ? "brightness(0) saturate(100%) invert(70%) sepia(99%) saturate(1000%) hue-rotate(10deg) brightness(102%) contrast(101%)" :
               color === "success" ? "brightness(0) saturate(100%) invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)" :
               color === "info" ? "brightness(0) saturate(100%) invert(53%) sepia(97%) saturate(1027%) hue-rotate(189deg) brightness(96%) contrast(88%)" :
               "brightness(0) saturate(100%)",
      }}
      {...safeProps}
    />
  );
}

CustomIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  active: PropTypes.bool,
};

CustomIcon.defaultProps = {
  color: "dark",
  fontSize: "14px",
};

export default CustomIcon;
